export function getLinkIconPosition(
  linkIconPosition: 'left' | 'right' | undefined
) {
  return linkIconPosition === 'right'
    ? 'icon-right'
    : linkIconPosition === 'left'
    ? 'icon-left'
    : 'no-icon';
}
